
import Vue from "vue"

export default Vue.extend({
  name: "PaginatedTable",
  props: {
    items: { // https://vuetifyjs.com/en/api/v-data-table/#props-items
      type: Array,
      required: true
    },
    headers: { // https://vuetifyjs.com/en/api/v-data-table/#props-headers
      type: Array,
      required: true
    },
    lastPage: { // pagination last page
      type: Number,
      default: 0,
      required: true
    },
    title: String, // table title
    tooltip: String, // table tooltip
    loading: { // loading bar, bind it if you want to activate the effect
      type: Boolean,
      default: false
    },
    multiSort: { // activate multiple columns sorting on table => https://vuetifyjs.com/en/api/v-data-table/#props-options
      type: Boolean,
      default: false
    },
  },
  data: () => ({
    totalItems: 0,
    page: 1,
    options: {
      page: 1,
      itemsPerPage: 25,
      sortBy: [],
      sortDesc: [],
      groupBy: [],
      groupDesc: [],
      multiSort: false,
      mustSort: false
    },
  }),
  created: function() {
    this.options.multiSort = this.multiSort
  },
  methods: {
    getData(): void {
      this.$emit('get-data', this.page, this.options)
    }
  },
  watch: {
    options: {
      handler () {
        this.getData()
      },
      deep: true,
    },
    page: {
      handler () {
        this.getData()
      },
      deep: true,
    }
  }
})
